import styled from "styled-components";
import {SIZES} from "@/components/constants";
import {useState} from "react";
import {isEmail} from "@/utils";
import {usePostContactMutation} from "@/api/helpApi";

const FormWrap = ({langData}) => {
    const [postContact] = usePostContactMutation();
    const [contactName, setContactName] = useState("");
    const [contactMail, setContactMail] = useState("");
    const [contactTel, setContactTel] = useState("");
    const [contactProduct, setContactProduct] = useState("");
    const [contactTitle, setContactTitle] = useState("");
    const [contactContent, setContactContent] = useState("");
    const [contactAgree, setContactAgree] = useState(false);



    const setContactSubmit = async () => {
        try {

            if (!contactName) {
                alert(`${langData["contact-name-alert"]}`);
                return;
            }
            if (!contactMail) {
                alert(`${langData["contact-email-alert"]}`);
                return;
            }
            if (!isEmail(contactMail)) {
                alert(`${langData["contact-email-format-alert"]}`);
                return;
            }
            if (!contactTel) {
                alert(`${langData["contact-tel-alert"]}`);
                return;
            }
            if (String(contactTel).length <= 9) {
                alert(`${langData["contact-tel-format-alert"]}`);
                return false;
            }
            if (!contactTitle) {
                alert(`${langData["contact-title-alert"]}`);
                return;
            }
            if (!contactContent) {
                alert(`${langData["contact-content-alert"]}`);
                return;
            }
            if (!contactAgree) {
                alert(`${langData["contact-agree-alert"]}`);
                return;
            }
            const patLoad = {
                name: contactName,
                email: contactMail,
                phone: contactTel,
                product: contactProduct,
                subject: contactTitle,
                message: contactContent,
                agree: contactAgree,
            }
            await postContact(patLoad).unwrap();
            alert(`${langData["contact-success-alert"]}`);
            setContactName("");
            setContactMail("");
            setContactTel("");
            setContactProduct("");
            setContactTitle("");
            setContactContent("");
            setContactAgree(false);
        } catch (e) {
            console.log(e)
            alert(`${langData["contact-error-alert"]}`);
        }
    }

    return(
        <ContactForm>
            <div className={"wrapper"}>
                <div className={"title"} dangerouslySetInnerHTML={{__html: langData["contact-form-name"]}}/>
                <input
                    type={"text"}
                    placeholder={`${langData["contact-placeholder-name"]}`}
                    onChange={(e) => setContactName(e.target.value)}
                    value={contactName}
                />
            </div>
            <div className={"grid"}>
                <div className={"wrapper"}>
                    <div className={"title"} dangerouslySetInnerHTML={{__html: langData["contact-form-email"]}}/>
                    <input
                        type={"text"}
                        placeholder={`${langData["contact-placeholder-email"]}`}
                        onChange={(e) => setContactMail(e.target.value)}
                        value={contactMail}
                    />
                </div>
                <div className={"wrapper"}>
                    <div className={"title"} dangerouslySetInnerHTML={{__html: langData["contact-form-tel"]}}/>
                    <input
                        type={"tel"}
                        placeholder={`${langData["contact-placeholder-tel"]}`}
                        inputMode={"numeric"}
                        onChange={(e) => setContactTel(e.target.value.replace(/\D/g, '').slice(0, 11))}
                        value={contactTel}
                    />
                </div>
            </div>
            <div className={"wrapper"}>
                <div className={"title"} dangerouslySetInnerHTML={{__html: langData["contact-form-product"]}}/>
                <input
                    type={"text"}
                    placeholder={`${langData["contact-form-product"]}`}
                    onChange={(e) => setContactProduct(e.target.value)}
                    value={contactProduct}
                />
            </div>
            <div className={"wrapper"}>
                <div className={"title"} dangerouslySetInnerHTML={{__html: langData["contact-form-title"]}}/>
                <input
                    type={"text"}
                    placeholder={`${langData["contact-placeholder-title"]}`}
                    onChange={(e) => setContactTitle(e.target.value)}
                    value={contactTitle}
                />
            </div>
            <div className={"wrapper bs"}>
                <div className={"title"} dangerouslySetInnerHTML={{__html: langData["contact-form-content"]}}/>
                <textarea
                    rows={4}
                    placeholder={`${langData["contact-placeholder-content"]}`}
                    onChange={(e) => setContactContent(e.target.value)}
                    value={contactContent}
                />
            </div>
            <div className={"contact-info"}>
                <p dangerouslySetInnerHTML={{__html: langData["contact-form-desc1"]}}/>
                <p dangerouslySetInnerHTML={{__html: langData["contact-form-desc2"]}}/>
            </div>
            <div className={"agree-wrap"}>
                <input
                    type="checkbox"
                    id="agree"
                    checked={contactAgree}
                    onChange={(e) => setContactAgree(e.target.checked)}
                />
                <label htmlFor="agree" dangerouslySetInnerHTML={{__html: langData["contact-form-agree"]}}/>
            </div>
            <div className={"contact-submit"} onClick={setContactSubmit}>
                <p dangerouslySetInnerHTML={{__html: langData["contact-form-button"]}}/>
            </div>
        </ContactForm>
    )
}
const ContactForm = styled.div`
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    row-gap: 24px;
    flex-direction: column;
    max-width: 840px;
    width: 100%;
    display: flex;

    .grid {
        gap: 16px;
        grid-template-columns: repeat(1, minmax(0, 1fr));
        display: grid;
    }
    .wrapper{
        padding: 16px 24px;
        border: 1px solid #dfdfe1;
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 16px;
        &.bs{
            align-items: baseline;
        }
        .title{
            font-weight: 700;
            flex-shrink: 1;
            width: 85px;
        }
        input{
            outline: none;
            border: none;
            flex-grow: 1;
            width: 0;
            font-size: 100%;
            padding: 0 10px;
            &::placeholder {
                color: #9ca3af;
            }
        }
        textarea{
            outline: none;
            border: none;
            flex-grow: 1;
            width: 0;
            font-size: 100%;
            padding: 0 10px;
            resize: none;
            &::placeholder {
                color: #9ca3af;
            }
        }
    }
    .contact-info{
        p{
            color: rgb(142 141 147 / 0.5);
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
        }
    }
    .agree-wrap{
        display: flex;
        align-items: center;
        gap: 16px;
        input{
            width: 24px;
            height: 24px;
            &:checked{
                accent-color: #07903A;
            }
        }
        label{
            font-weight: 500;
            cursor: pointer;
            font-size: 18px;
        }
    }
    .contact-submit{
        font-weight: 700;
        text-align: center;
        color: #fff;
        padding: 24px 0;
        display: block;
        width: 100%;
        background-color: #000;
        border-radius: 16px;
        cursor: pointer;
    }
    @media (min-width: ${SIZES.MOBILE_L}) {
        .grid{
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
`
export default FormWrap;
